module.exports = __webpack_public_path__ + "static/media/save_w.cb8d0813.svg";